import React, { useState, useEffect, useRef } from "react";
import tw from "twin.macro";
import styled from "styled-components";
import Realestate from "../../Images/Real-estate-software-development.svg";
import Footer from "../Footer/Footer.js";
import DetailsCard from "../WhatWeDo/components/DetailsCard.js";
import cardData from "../../resources/cardData.json";
import logoTextData from "../../resources/logoTextData.json";
import imageHeader from "../../resources/imageHeader.json";
import SubHeadings from "../WhatWeDo/components/SubHeadings.js";
import ImageHeader from "../WhatWeDo/components/ImageHeader.js";

import realEstate from "../../Images/realEstateImage.jpg";
import { ReactComponent as Trending } from "feather-icons/dist/icons/trending-up.svg";
import { ReactComponent as Search } from "feather-icons/dist/icons/home.svg";
import { ReactComponent as Collab } from "feather-icons/dist/icons/users.svg";
import { ReactComponent as Settings } from "feather-icons/dist/icons/settings.svg";
import { ReactComponent as Cloud } from "feather-icons/dist/icons/cloud-rain.svg";
import { ReactComponent as Tool } from "feather-icons/dist/icons/phone-call.svg";
import { ReactComponent as File } from "feather-icons/dist/icons/file-plus.svg";
import { ReactComponent as Refresh } from "feather-icons/dist/icons/refresh-ccw.svg";
import { ReactComponent as Houses } from "../../Images/houses.svg";
import { ReactComponent as Contract } from "../../Images/journal-check.svg";
import { ReactComponent as Inventory } from "../../Images/building-gear.svg";
import { ReactComponent as Bank } from "../../Images/bank.svg";
import { ReactComponent as Currency } from "../../Images/coin.svg";
import { ReactComponent as Shop } from "../../Images/shop.svg";
import { ReactComponent as FileText } from "feather-icons/dist/icons/file-text.svg";
import { ReactComponent as Receipt } from "../../Images/receipt.svg";
import { ReactComponent as Calender } from "feather-icons/dist/icons/calendar.svg";
import { ReactComponent as Claim } from "../../Images/shield-check.svg";
import { ReactComponent as Cube } from "../../Images/boxes.svg";
import { ReactComponent as Bulb } from "../../Images/bulb.svg";
import IconCard from "../WhatWeDo/components/IconCard.js";
import { ReactComponent as Code } from "feather-icons/dist/icons/code.svg";
import { ReactComponent as Database } from "feather-icons/dist/icons/database.svg";
import { ReactComponent as Location } from "feather-icons/dist/icons/map-pin.svg";
import { ReactComponent as Dollar } from "feather-icons/dist/icons/dollar-sign.svg";
import { ReactComponent as Message } from "feather-icons/dist/icons/message-square.svg";
import { ReactComponent as Key } from "feather-icons/dist/icons/key.svg";
import { ReactComponent as DollarIcon } from "feather-icons/dist/icons/dollar-sign.svg";
import { ReactComponent as Award } from "feather-icons/dist/icons/award.svg";
import RealEstateTechstack from "../Techstack/RealEstateTechstack.js";
import ContactUs from "../Contact/ContactUs.js";
import WhoWeArePDF from "./CommonPages/WhoWeArePDF.js";
import { ContactUsPDF } from "./CommonPages/ContactUsPDF.js";
import TeckStackPDF from "./CommonPages/TeckStackPDF.js";
import Slider from "./../../components/WhatWeDo/components/Slider.js";
import SliderPage from "../WhatWeDo/components/SliderPage.js";

const ThreeColumnContainer = styled.div`
  ${tw`mt-1 flex flex-col items-center lg:items-stretch lg:flex-row  md:flex-row md:items-stretch md:justify-center sm:flex-wrap lg:justify-center max-w-screen-lg mx-auto`}
`;
const Container = tw.div`relative  bg-center 
bg-no-repeat
h-screen
w-full  `;
const LogoContainer = tw.div`flex lg:justify-end absolute z-1 w-full`;
const LogoText = tw.h5`ml-0 text-6xl pt-5 text-indigo-600 font-bold `;
const Wrapper = tw.div`max-w-screen-xl mx-auto py-2  mb-20`;
const WrapperDescription = tw.div`max-w-screen-xl mx-auto shadow-lg`;
const Description = tw.p`px-6 font-semibold py-5 my-10 text-sm md:text-xl text-gray-900 text-center`;
const TwoCol = styled.div`
  ${tw`flex justify-between max-w-screen-xl mx-auto`}
`;

let data = [
  {
    imageSrc: <Bulb />,
  },
  {
    imageSrc: <DollarIcon />,
  },
  {
    imageSrc: <Award />,
  },
  {
    imageSrc: <Trending />,
  },
  {
    imageSrc: <Settings />,
  },
  {
    imageSrc: <Collab />,
  },
];

const imgStyle = { width: "40px", height: "40px" };

let ExpertiseData = [
  {
    imageSrc: <Search style={imgStyle} />,
  },
  {
    imageSrc: <Cloud style={imgStyle} />,
  },
  {
    imageSrc: <Houses style={imgStyle} />,
  },
  {
    imageSrc: <Trending style={imgStyle} />,
  },
  {
    imageSrc: <Settings style={imgStyle} />,
  },
  {
    imageSrc: <Tool style={imgStyle} />,
  },
  {
    imageSrc: <Currency style={imgStyle} />,
  },
  {
    imageSrc: <Bank style={imgStyle} />,
  },
];

let ServicesData = [
  {
    imageSrc: <Shop style={imgStyle} />,
  },
  {
    imageSrc: <FileText style={imgStyle} />,
  },
  {
    imageSrc: <Receipt style={imgStyle} />,
  },
  {
    imageSrc: <Calender style={imgStyle} />,
  },
  {
    imageSrc: <File style={imgStyle} />,
  },
  {
    imageSrc: <Claim style={imgStyle} />,
  },
  {
    imageSrc: <Cube style={imgStyle} />,
  },
  {
    imageSrc: <Refresh style={imgStyle} />,
  },
  {
    imageSrc: <Contract style={imgStyle} />,
  },
  {
    imageSrc: <Inventory style={imgStyle} />,
  },
];

const keyBenefits = cardData.realEstate.keyBenefits.map((item, index) => (
  <DetailsCard
    key={index}
    title={item.point}
    description={item.description}
    imageSrc={data[index].imageSrc}
  />
));

const ourExpertise = logoTextData.realestate.ourexpertise.map((item, index) => (
  <IconCard
    key={index}
    title={item.title}
    description={item.description}
    imageSrc={ExpertiseData[index].imageSrc}
  />
));

const ourServices = logoTextData.realestate.ourservices.map((item, index) => (
  <IconCard
    key={index}
    title={item.title}
    description={item.description}
    imageSrc={ServicesData[index].imageSrc}
  />
));

const RealEstatePagePDF = ({ imagehalf, title, title1 }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  let [current, setCurrent] = useState(0);

  let nextSlide = () => {
    if (current === slides.length - 1) setCurrent(0);
    else setCurrent(current + 1);
  };

  useEffect(() => {
    const intervalId = setInterval(nextSlide, 10000); // Change 5000 to adjust interval time (in milliseconds)
    return () => clearInterval(intervalId);
  }, [current]);
  let slidesData = [
    {
      image: realEstate,
      typeID: "element2",
      typedHead:
        "We bring our deep expertise of the U.S. real estate market to your advantage|",
      heading1: "Real Estate  ",
      heading2: "Software Development Company",
      route: "/what-we-do/real-estate-software-company",
      routeState: "",
      buttonName: "Visit",
    },
  ];

  let slides = [<SliderPage slidesData={slidesData[0]} imagehalf={true} />];

  useEffect(() => {
    document.title =
      "Welcome to Iqura - Real Estate Software Development Company";
    let descMeta = document.querySelector("meta[name='description']");
    descMeta.setAttribute(
      "content",
      "Iqura is having decades of experience in real estate software solutions and make a great addition to your IT teams and systems with our wide ranging technologies and industry specific experience."
    );
    let keyword = document.querySelector("meta[name='keywords']");
    keyword.setAttribute(
      "content",
      "Contract and Claims management, Inventory management, Vendor management,Renewals management, Invoicing systems,Document publishing and Report automation, Provider matching, Scheduling, Routing and Dispatch,Authorizations and Cost management, Order processing and Management, Customer ordering, Storefronts and Customer management, Mortgages, Loans and Brokerage management systems, Title and transaction management systems,Realtors and Service Provider systems,MLS Integrations, Property listings and Marketplaces systems, Home Inspection software, Natural Hazards Disclosure software, Home Warranty software,Location &  Address Integrations, Real Estate Property &  Database Integrations,Document  automation, Accounting & Payment  Systems Integrations,Messaging &  Communications Integrations and Identity &  Access Management Integrations"
    );
    const link = document.createElement("link");
    link.rel = "canonical";
    link.href =
      "https://www.iqura.tech/what-we-do/real-estate-software-company";
    document.head.appendChild(link);

    return () => {
      document.head.removeChild(link);
    };
  }, []);

  let data = [
    {
      imageSrc: <Location style={imgStyle} />,
    },
    {
      imageSrc: <Database style={imgStyle} />,
    },
    {
      imageSrc: <Code style={imgStyle} />,
    },
    {
      imageSrc: <Dollar style={imgStyle} />,
    },
    {
      imageSrc: <Message style={imgStyle} />,
    },
    {
      imageSrc: <Key style={imgStyle} />,
    },
  ];

  const integrationSpecialities =
    logoTextData.thirdpartyintegrations.integrationspecialities.map(
      (item, index) => (
        <IconCard
          readmore={true}
          key={index}
          title={item.title}
          url={item.url}
          description={item.description}
          imageSrc={data[index].imageSrc}
        />
      )
    );

  return (
    <div className="overflow-hidden relative ">
      <LogoContainer>
        <div className="flex lg:justify-end w-full mr-16 ">
          <LogoText className="logoFontFamily">Iqura</LogoText>
        </div>
      </LogoContainer>
      <div
        style={{ visibility: "hidden", position: "absolute", top: "-9999px" }}
      >
        <Slider />
      </div>
      <div></div>
      <div className="" style={{ height: "100vh" }}>
        <div className="flex justify-center" style={{ height: "100vh" }}>
          <div className="overflow-hidden relative">
            <div
              className="flex transition-transform ease-out duration-300"
              style={{
                transform: `translateX(-${current * 100}%)`,
              }}
            >
              {slides.map((s) => {
                return (
                  <div className="z-22" style={{ width: "100%" }}>
                    {s}
                  </div>
                );
              })}
            </div>

            <div className="absolute bottom-0 flex justify-center gap-3 w-full   ">
              {slides.map((s, i) => {
                return (
                  <div
                    onClick={() => {
                      setCurrent(i);
                    }}
                  ></div>
                );
              })}
            </div>
          </div>
        </div>

        <TwoCol>
          <WrapperDescription>
            <Description
              style={{
                backgroundColor: "white",
                marginTop: `${window.innerWidth <= 425 ? -140 : -350}px`,
                padding: "40px",
                transform: "scale(1.25)",
              }}
            >
              <ImageHeader
                imageHeaderData={imageHeader.realEstate}
                imgsource={Realestate}
              />
            </Description>
          </WrapperDescription>
        </TwoCol>
      </div>
      <WhoWeArePDF />
      <div
        className="  flex justify-center items-center  "
        style={{ height: "100vh" }}
      >
        <div className="px-20 pb-32" style={{ transform: "scale(1.35)" }}>
          <div>
            <div id="ourexpertise" className="div-class"></div>
            <SubHeadings heading1="Our" heading2="Expertise" />
            <ThreeColumnContainer>{ourExpertise}</ThreeColumnContainer>
          </div>
        </div>
      </div>
      <TeckStackPDF />
      <ContactUsPDF />
    </div>
  );
};

export default RealEstatePagePDF;
